__turbopack_context__.v({
  "root": "InlineFilters-Type-module-scss-module__OiKzeW__root",
});
